module.exports = __webpack_public_path__ + "img/c5201909-5.b54e17ee.jpg";